<ul class="nav">
  <li><a routerLink="/">Home</a></li>
  <li><a routerLink="/products">Products</a></li>
  <li><a routerLink="/contact">Contact</a></li>
</ul>
